<template>
	<svg class="LogoLabShort" :class="classes" viewBox="0 0 360 68" role="img" :aria-labelledby="id">
		<title :id="id">The Cornell Lab logo</title>
		<g fill="none" fill-rule="evenodd">
			<path
				class="LogoLabShort-theCornellLab"
				fill="#000"
				d="M11.09 21.102V51.03h2.873V21.102H24.26v-2.595H.79v2.595h10.22m25.842 8.314c-3.42-.002-6.175 1.913-7.267 4.228l-.022.048h-.152V18.507h-2.59V51.03h2.6V40.502c.01-5.868 3.31-8.757 7.44-8.768 4.43.01 5.41 3.43 5.42 6.882V51.03h2.6V38.477c0-4.63-1.43-9.05-8-9.06zM59.467 49.26c-6.5 0-8.12-5.752-8.128-8.07v-.08h17.84v-1.85c-.01-4.882-3.42-9.84-9.9-9.844-6.17.006-10.54 4.737-10.55 11.043 0 6.53 4.23 11.12 10.68 11.12 3.73 0 6.94-1.31 9.09-4.46l-1.89-1.59c-1.43 2.28-4.35 3.72-7.15 3.72zM51.34 38.708c.002-1.14 1.72-6.96 7.806-6.973 4.133.01 7.44 3.158 7.44 6.973v.08H51.338v-.08zm43.17-11.75c-1.426-1.7-3.495-2.665-6.162-2.665-5.428 0-9.428 4.41-9.428 10.475 0 6.066 4 10.475 9.198 10.475 2.897 0 5.24-1.286 6.715-3.492l5.975 4.46c-2.712 3.86-7.313 5.65-11.774 5.65-10.162 0-17.566-6.66-17.566-17.09 0-10.42 7.404-17.09 17.566-17.09 3.634 0 8.23 1.24 10.992 4.78l-5.516 4.5zm18.743 1.195c6.9 0 12.415 4.596 12.415 11.715 0 7.122-5.516 11.718-12.415 11.718-6.897 0-12.415-4.596-12.415-11.718 0-7.12 5.518-11.715 12.415-11.715zm0 17.367c3.45 0 5.52-2.297 5.52-5.653 0-3.353-2.07-5.65-5.52-5.65-3.45 0-5.516 2.297-5.516 5.65 0 3.356 2.07 5.652 5.516 5.652zm14.968-16.816h6.9v3.585h.09c1.48-2.72 3.41-4.14 6.44-4.14.79 0 1.66.04 2.3.23v6.29c-.96-.28-1.93-.47-2.94-.47-5.24 0-5.88 3.03-5.88 7.49v9.32h-6.9V28.7h.01zm17.7 0h6.62v3.03h.1c.92-1.744 3.17-3.582 6.53-3.582 6.99 0 8.28 4.596 8.28 10.565V51.03h-6.89V40.094c0-2.57-.04-5.88-3.58-5.88-3.58 0-4.14 2.804-4.14 5.698V51.03h-6.89V28.704zm45.71 18.466c-2.2 2.806-5.84 4.412-9.42 4.412-6.89 0-12.42-4.596-12.42-11.718 0-7.12 5.52-11.715 12.42-11.715 6.44 0 10.48 4.59 10.48 11.71v2.16h-16c.55 2.61 2.53 4.31 5.2 4.31 2.26 0 3.77-1.15 4.93-2.71l4.83 3.54zm-5.84-9.83c.05-2.293-1.75-4.224-4.23-4.224-3.03 0-4.69 2.064-4.87 4.225h9.11zm9.34-2.6V18.507h6.9V51.03h-6.89m10.95-16.29V18.507h6.9V51.03h-6.89m15-16.29V18.507h-2.88V51.03h16.145v-2.593h-13.27m31.94-11.427c-.01-5.335-3.253-7.58-8.38-7.594-2.72 0-5.98 1.038-7.985 2.913l1.505 1.76c1.89-1.59 4.01-2.36 6.48-2.36 3.42.01 6.06 1.5 6.06 5.23v1.36h-3.3c-2.09 0-5.02.16-7.42 1.13-2.4.96-4.26 2.71-4.264 5.91 0 4.44 3.8 6.21 7.416 6.21 3.567 0 5.823-1.27 7.38-3.96l.024-.04h.216v.08c0 1.16.09 2.33.264 3.36h2.412c-.31-2.41-.4-4.75-.4-8.84V37zm-2.324 4.868c0 1.78-.38 3.625-1.51 5.033-1.132 1.41-3.012 2.36-5.97 2.36h-.003c-2.323 0-4.905-1.34-4.907-4.03.013-3.72 4.674-4.85 9.275-4.85h3.115v1.5h-.003zm17.81-12.464c-3.15 0-6.756 1.33-8.435 4.235l-.02.04h-.22V18.5h-2.6v32.53h2.6v-3.72h.22l.03.042c1.68 2.904 5.287 4.23 8.44 4.23 6.49-.003 11.088-4.647 11.094-11.08-.007-6.44-4.604-11.083-11.095-11.088zm0 19.847c-5.052 0-8.945-3.93-8.953-8.75.008-4.82 3.9-8.75 8.955-8.76 5.24.01 8.487 3.95 8.498 8.77-.01 4.81-3.254 8.76-8.495 8.76z"
			/>
			<g class="LogoLabShort-sapsucker">
				<path
					fill="#FFF"
					d="M356.176 10.163c-.94-.34-3.74-1.22-4.937-1.595-1.2-.382-4.6-1.366-5.6-1.665-.36-.483-.74-.875-1.04-1.165-3.3-3.51-8.33-5.605-13.44-5.605-5.82 0-10.17 1.918-11.66 2.673h-75.93v2.147c0 3.23 3.72 5.666 8.67 5.666h20.92l16.94 11.96v18.34c0 9.04 4.77 17.23 12.76 21.9 6.68 3.91 10.71 4.22 15.29 4.22.33 0 .66-.01.99-.01l1.05-.01h2.15V28.86l1.43-1.054L342.4 14.1s9.783-.607 12.263-.767c1.378-.088 2.932-.22 4.016-.347.99-.117 1.4-.432 1.4-.69 0-.313-.19-.435-.42-.61-.19-.145-1.67-.865-3.49-1.524z"
				/>
				<path
					fill="#000"
					d="M356.603 11.57s-8.832-2.328-12.228-2.626c0 0-13.438 7.244-17.202 9.68-3.77 2.432-4.486 6.092-4.654 7.455l19.18-14.13h15.03c.38 0-.13-.39-.13-.39z"
				/>
				<path
					fill="#000"
					d="M325.54 17.285c3.934-2.625 17.52-10.056 17.52-10.056s.017.01.02.02c-2.328-2.5-6.56-4.97-11.913-4.97-6.584 0-11.123 2.67-11.123 2.67h-74.316c0 1.99 3.007 3.51 6.523 3.51h21.62l18.41 13v19.46c0 8.44 4.44 15.8 11.7 20.05 7.26 4.24 10.9 3.92 16.25 3.92V27.78c0-3.27.99-7.594 5.33-10.493zm11.73-9.053c0 .744-.608 1.35-1.35 1.35-.746 0-1.352-.606-1.352-1.35 0-.742.61-1.348 1.35-1.348.744 0 1.352.606 1.352 1.348zm-17 5.63l8.427-4.66 3.703.305-12.13 6.724v-2.36z"
				/>
				<path fill="#F0E614" d="M273.862 8.472h30.976c-6.925 0-12.57 5.558-12.57 13l-18.406-13z" />
				<path
					fill="#E60000"
					d="M341.374 8.162c-2.448-2.083-6.304-3.988-10.877-3.988v-1.88l.67-.013c5.348 0 9.566 2.46 11.894 4.95l-1.68.94zm.323 3.793l-13.422 9.888s-.16-1.446 1.86-3.075c2.02-1.63 14.24-9.822 14.24-9.822l-2.678 3.01z"
				/>
				<path
					fill="#FFF"
					d="M314.573 37.226V30.61c0-2.78-1.135-4.704-3.725-6.534l-10.97-7.746c-1.23 1.344-1.976 3.144-1.976 5.148 0 2.496 1.2 4.708 3.044 6.113l13.627 9.64z"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	data() {
		return {};
	},
	props: {
		/**
		 * unique ID automatically generated if not set
		 */
		id: {
			type: String,
			default: 'id-' + Math.random().toString(36).substr(2, 9),
		},
		/**
		 * for use on dark background
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * can be xs, sm, lg, xl, or responsive
		 */
		size: {
			type: String,
			default: null,
		},
	},
	computed: {
		classes() {
			return {
				'LogoLabShort--reverse': this.reverse,
				'LogoLabShort--xs': this.size === 'xs',
				'LogoLabShort--sm': this.size === 'sm',
				'LogoLabShort--lg': this.size === 'lg',
				'LogoLabShort--xl': this.size === 'xl',
				'LogoLabShort--xxl': this.size === 'xxl',
				'LogoLabShort--responsive': this.size === 'responsive',
			};
		},
	},
};
</script>

<style lang="scss">
/* Original dimensions of svg - used for calculating width from height */
$logo-lab-short-orig-w: 360;
$logo-lab-short-orig-h: 68;
/* Units to be used below */
$logo-lab-short-units: rem;

/* Default logo style */
.LogoLabShort {
	$logo-lab-short-h-md: 1.75;
	$logo-lab-short-w-md: calc-width-from-height($logo-lab-short-orig-w, $logo-lab-short-orig-h, $logo-lab-short-h-md);
	height: #{$logo-lab-short-h-md}#{$logo-lab-short-units};
	width: #{$logo-lab-short-w-md}#{$logo-lab-short-units};
	max-width: 100%; /* Ensure svg will shrink with container */
	vertical-align: middle; /* Safety if width or height are overridden out of ratio */
}

/* ----------------
	Variants
---------------- */

/* Reverse variant for dark backgrounds */
.LogoLabShort--reverse {
	.LogoLabShort-theCornellLab {
		fill: #fff;
	}
	.LogoLabShort-ofOrnithology {
		fill: #fff;
	}
}

/* Extra small (xs) variant */
.LogoLabShort--xs {
	$logo-lab-short-h-xs: 1.25;
	$logo-lab-short-w-xs: calc-width-from-height($logo-lab-short-orig-w, $logo-lab-short-orig-h, $logo-lab-short-h-xs);
	height: #{$logo-lab-short-h-xs}#{$logo-lab-short-units};
	width: #{$logo-lab-short-w-xs}#{$logo-lab-short-units};
}

/* Small (sm) variant */
.LogoLabShort--sm {
	$logo-lab-short-h-sm: 1.5;
	$logo-lab-short-w-sm: calc-width-from-height($logo-lab-short-orig-w, $logo-lab-short-orig-h, $logo-lab-short-h-sm);
	height: #{$logo-lab-short-h-sm}#{$logo-lab-short-units};
	width: #{$logo-lab-short-w-sm}#{$logo-lab-short-units};
}

/* Large (lg) variant */
.LogoLabShort--lg {
	$logo-lab-short-h-lg: 2;
	$logo-lab-short-w-lg: calc-width-from-height($logo-lab-short-orig-w, $logo-lab-short-orig-h, $logo-lab-short-h-lg);
	height: #{$logo-lab-short-h-lg}#{$logo-lab-short-units};
	width: #{$logo-lab-short-w-lg}#{$logo-lab-short-units};
}

/* Extra large (xl) variant */
.LogoLabShort--xl {
	$logo-lab-short-h-xl: 2.25;
	$logo-lab-short-w-xl: calc-width-from-height($logo-lab-short-orig-w, $logo-lab-short-orig-h, $logo-lab-short-h-xl);
	height: #{$logo-lab-short-h-xl}#{$logo-lab-short-units};
	width: #{$logo-lab-short-w-xl}#{$logo-lab-short-units};
}

/* Extra large (xl) variant */
.LogoLabShort--xxl {
	$logo-lab-short-h-xxl: 3;
	$logo-lab-short-w-xxl: calc-width-from-height($logo-lab-short-orig-w, $logo-lab-short-orig-h, $logo-lab-short-h-xxl);
	height: #{$logo-lab-short-h-xxl}#{$logo-lab-short-units};
	width: #{$logo-lab-short-w-xxl}#{$logo-lab-short-units};
}
</style>
